// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_cart_empty = /** @type {(inputs: {}) => string} */ () => {
	return `Your cart is empty`
};

const el_cart_empty = /** @type {(inputs: {}) => string} */ () => {
	return `Το καλάθι σας είναι άδειο`
};

const ru_cart_empty = /** @type {(inputs: {}) => string} */ () => {
	return `Ваша корзина пуста`
};

const he_cart_empty = /** @type {(inputs: {}) => string} */ () => {
	return `הסל שלך ריק`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cart_empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cart_empty(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cart_empty", locale)
	if (locale === "en") return en_cart_empty(inputs)
	if (locale === "el") return el_cart_empty(inputs)
	if (locale === "ru") return ru_cart_empty(inputs)
	if (locale === "he") return he_cart_empty(inputs)
	return "cart_empty"
};